import ObjectID from "bson-objectid"

export class DataService {
  static id(): string {
    return ObjectID().toHexString()
  }
}

